import React, { Component,Fragment } from 'react';
import { Highlighter, AsyncTypeahead } from 'react-bootstrap-typeahead';
import { connect } from 'react-redux';
import {
	BRANCH_ACCESS
} from '../../../constants/general';
import { getAllClients }     from '../../../store/actions/clientActions';


class SearchClient extends Component {

	constructor(props) {
		super(props);
	    this.state = {
			isLoading:false,
			openSearcher:true,
			selected:"",
			clients: [],
            placeholder:'Buscar usuario'
		}
		// this.props.getAllClients()
	}

	componentDidUpdate(prevProps){
		let newList = [];
		let { clients, userHigherAccess } = this.props;

		if ((prevProps.clients  && prevProps.clients.data && prevProps.clients.data.length) !== (clients.data && clients.data.length) && userHigherAccess > BRANCH_ACCESS) {
            newList = clients.data.map(b => { return { access_id: b.id, related_access: b } })

			newList = newList.concat({access_id:-1,related_access: {id:-1,name:this.state.placeholder}})
			this.setState({ clients: newList })
		}
	}

	SearchAction(query){
		let { userHigherAccess } = this.props;
		if(userHigherAccess > BRANCH_ACCESS){
			this.props.getAllClients(1,query)
		}
	}

	render () {
		return (
			<Fragment>
                <AsyncTypeahead
                    ref={(ref) => this._typeahead = ref}
                    labelKey="name"
                    options={ this.state.clients.map($0 => $0.related_access)}
                    onChange={this.props.change}
                    onSearch={(query) => this.SearchAction(query)}
                    isLoading={this.state.isLoading}
                    value={this.state.selected}
                    placeholder={this.state.placeholder}
                    renderMenuItemChildren={
                        (option, props, index) => <div className="normaltext-autocomplete" style={{display: `flex`,gap: `10px`}}>
                            <img className="avatar_small"
                                src={option.avatar_url}
                                ref={ `avatar_url`}
                                onError={ ()=>this.refs[`avatar_url`].src= 'https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar-comprador.png' }
                                alt={option.name}/>
                            <div style={{width: `calc(100% - 40px)`}}>
                                {option.name}<br/>
                                <small>{option.email}</small>
                            </div>
                        </div>
                    }/>
			</Fragment>
		)
	}
}


const mapStateToProps = (state) => {
	//console.log("dashboard",state.dashboardStatistics && state.dashboardStatistics.orders && state.dashboardStatistics.orders.ongoing && state.dashboardStatistics.orders.ongoing.hanging)
	return {
		admin_type:state.session && state.session.admin_type && state.session.admin_type.name,
		company:state.company,
		userHigherAccess: state.userHigherAccess,
		errors: state.errors,
		json_lang: state.json_lang,
		clients:state.allClients
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		getAllClients: (page,query) => dispatch(getAllClients(page,query)),
	}
}

export default connect(mapStateToProps , mapDispatchToProps)(SearchClient);



// WEBPACK FOOTER //
// ./src/views/Plugins/SpecialForm/SearchClient.js